import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GESTION_CONFIG } from 'src/environments/environment.config';
import { HttpService } from '../../../core/core/services/http.service';

export interface PeriodoActivoResponse {
  mes: number;
  anio: number;
  fechaActivacion: string;
}

@Injectable({
  providedIn: 'root',
})
export class PeriodoActivoService {
  private readonly baseUrl = `${environment.url_ms_base}${environment.login_conf.DOMAIN_ROUTE}${GESTION_CONFIG.PERIODO_ACTIVO_ENDPOINT}`;

  constructor(private readonly http: HttpService) {}

  getPeriodoActivo$(): Observable<PeriodoActivoResponse> {
    return this.http.get<PeriodoActivoResponse>(this.baseUrl);
  }

  updatePeriodoActivo$(mes: number, anio: number): Observable<PeriodoActivoResponse> {
    return this.http.put<PeriodoActivoResponse>(this.baseUrl, { mes, anio });
  }
}
